// All the common constants
export const GENERIC_ERROR_FLAG_ID = 'genericError';
